module.exports = __webpack_public_path__ + "img/information.c3b0dcc1.png";